import { useFilterStore } from "../store/useFilterStore";

export default {
  data() {
    return {
      // These should match the names in your component's data
      // filterModuleName: 'member', 
    };
  },

  methods: {
    /**
     * Initialize filters from the store. 
     * Call this in mounted() or before the first API call.
     */
    initFilters(moduleName) {
      this.filterModuleName = moduleName;
      const filterStore = useFilterStore();
      const saved = filterStore.getFilters(moduleName);
      
      if (saved) {
        if (saved.search !== undefined) this.search = saved.search;
        if (saved.page !== undefined) this.page = Number(saved.page) || 1;
        if (saved.itemsPerPage !== undefined) this.itemsPerPage = Number(saved.itemsPerPage) || 10;
        
        // Handle custom filters like selected_flat
        if (saved.selected_flat !== undefined) this.selected_flat = saved.selected_flat;
        
        // If there are other specific filters, you can extend this in the component
      }
    },

    /**
     * Save current filters to the store.
     * Call this whenever a filter changes.
     */
    syncFilters() {
      if (!this.filterModuleName) return;
      const filterStore = useFilterStore();
      
      const filterData = {
        search: this.search,
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };

      // List of possible filter keys to automatically sync if they exist in the component
      const commonFilters = [
        'selected_flat', 
        'selected_status', 
        'date_range', 
        'activeTabId',
        'selected_type',
        'selected_block',
        'date'
      ];

      commonFilters.forEach(key => {
        if (this[key] !== undefined) {
          filterData[key] = this[key];
        }
      });

      filterStore.updateFilters(this.filterModuleName, filterData);
    }
  },

  watch: {
    // Watch common filter fields and sync automatically
    search() { this.syncFilters(); },
    page() { this.syncFilters(); },
    itemsPerPage() { this.syncFilters(); },
    selected_flat() { this.syncFilters(); },
    selected_status() { this.syncFilters(); },
    activeTabId() { this.syncFilters(); },
  }
};
